<div class="cancel-container">
  <div class="cancel-content">
    <div class="cancel-icon">
      <mat-icon>highlight_off</mat-icon>
    </div>
    
    <h2>Payment Cancelled</h2>
    <p>Your payment process was cancelled. No charges have been made to your account.</p>
    
    <div class="cancel-message">
      <p>You can try again whenever you're ready. If you encountered any issues during the payment process, please contact our support team.</p>
    </div>
    
    <div class="action-buttons">
      <button mat-raised-button color="primary" (click)="goToBilling()">
        Return to Plans
      </button>
      
      <button mat-stroked-button (click)="goToDashboard()">
        Go to Dashboard
      </button>
    </div>
  </div>
</div>